import React from 'react';
import PropTypes from 'prop-types';
import NewsItem from './NewsItem/NewsItem';
import { NewsItemsContent, NewsItemsWrapper } from './styles/NewsItemsStyled';

const NewsItems = ({ data }) => {
  const items = data.map(item => (
    <NewsItem
      title={item.title}
      image={item.image}
      label={item.label}
      body={item.body}
      callToAction={item.callToAction}
      callToActionLink={item.callToActionLink}
      updatedAt={item.updatedAt}
      key={item.id}
    />
  ));

  return (
    <NewsItemsContent>
      <NewsItemsWrapper>{items}</NewsItemsWrapper>
    </NewsItemsContent>
  );
};

NewsItems.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      image: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      body: PropTypes.objectOf(PropTypes.shape).isRequired,
      callToAction: PropTypes.string,
      callToActionLink: PropTypes.string,
      updatedAt: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default NewsItems;
